export {default} from './MailingList';



// WEBPACK FOOTER //
// ./src/pages/MailingList/index.ts